module.exports = __webpack_public_path__ + "static/media/varun.e3471c75.png";